/* Larrysa's — motor de língua PT/EN.
   Traduz por correspondência exacta de texto (PT no HTML é a fonte; EN vem de window.LARRYSA_EN).
   Injecta o "Início" e o toggle PT/EN onde faltarem (ou um toggle flutuante em páginas sem nav).
   Expõe window.larrysaApplyLang(), window.larrysaT(pt) e window.larrysaLang para conteúdo dinâmico.
   Persiste em localStorage. */
(function(){
  var EN = (typeof window!=='undefined' && window.LARRYSA_EN) ? window.LARRYSA_EN : {};
  var currentLang = 'pt';
  var renderedSources = new Map();
  var templateKeys = Object.keys(EN).filter(function(k){return k.indexOf('§')!==-1;}).sort(function(a,b){return b.replace(/§/g,'').length-a.replace(/§/g,'').length;});
  function english(raw){
    if(EN[raw]!==undefined)return EN[raw];
    var pm=/^(·\s*)?(\d+),(\d{2})\s?€$/.exec(raw); if(pm)return (pm[1]||'')+'€'+pm[2]+'.'+pm[3]; /* 26 Out: preços em EN, 26,00 € -> €26.00 */
    for(var i=0;i<templateKeys.length;i++){
      var key=templateKeys[i],parts=key.split('§');
      var escaped=parts.map(function(part){return part.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');});
      var match=raw.match(new RegExp('^'+escaped.join('(.+?)')+'$'));
      if(match){var n=0;return EN[key].replace(/§/g,function(){var v=match[++n];return EN[v]===undefined?v:EN[v];});}
    }
    return undefined;
  }


  var CSS = '.langtog{display:inline-flex;align-items:center;position:relative;background:rgba(127,127,127,.16);border-radius:999px;padding:3px}'
    + '.langtog button{appearance:none;-webkit-appearance:none;border:0;background:transparent;cursor:pointer;font-family:inherit;font-weight:700;font-size:.72rem;line-height:1;min-width:44px;min-height:44px;letter-spacing:.06em;color:inherit;opacity:.55;padding:.42em .72em;border-radius:999px;position:relative;z-index:1;transition:opacity .25s}'
    + '.langtog button.on{opacity:1}'
    + '.langtog__knob{position:absolute;top:3px;bottom:3px;left:3px;width:calc(50% - 3px);background:rgba(255,255,255,.92);border-radius:999px;box-shadow:0 1px 4px rgba(0,0,0,.22);transition:transform .28s cubic-bezier(.4,1.05,.5,1)}'
    + '.langtog.is-en .langtog__knob{transform:translateX(100%)}'
    + '.langtog--float{position:fixed;top:.9rem;right:.9rem;z-index:9999;color:#fff;background:rgba(20,12,8,.55);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}';

  function injectStyle(){ if(document.getElementById('langtog-css'))return; var s=document.createElement('style'); s.id='langtog-css'; s.textContent=CSS; document.head.appendChild(s); }

  function walk(node, fn){
    for(var n=node.firstChild;n;n=n.nextSibling){
      if(n.nodeType===3){ fn(n); }
      else if(n.nodeType===1){ var t=n.tagName; if(!n.matches('.chat-bubble.user,[data-private-copy]')&&t!=='SCRIPT'&&t!=='STYLE'&&t!=='NOSCRIPT'&&t!=='TEXTAREA'&&n.getAttribute('translate')!=='no'&&!n.hasAttribute('data-hub-copy-en')) walk(n,fn); }
    }
  }

  var TITLE={};

  function trVal(lang, raw, store, key0, set){
    if(raw==null) return;
    var key=(''+raw).trim(); if(!key) return;
    if(store[key0]===undefined && renderedSources.has(key)){store[key0]=(''+raw).replace(key,renderedSources.get(key));store[key0+'En']=raw;}
    var keyN=key.replace(/\u00A0/g,' '); // nbsp da tipografia.js não deve falhar o lookup
    if(store[key0]!==undefined && (''+raw).replace(/\u00A0/g,' ')!==(''+store[key0]).replace(/\u00A0/g,' ') && (''+raw).replace(/\u00A0/g,' ')!==(''+(store[key0+'En']||'')).replace(/\u00A0/g,' ')){delete store[key0];delete store[key0+'En'];}
    if(lang==='en'){ var en=english(keyN); if(en!==undefined){ if(store[key0]===undefined)store[key0]=raw; store[key0+'En']=(''+raw).replace(key,en); if(raw!==store[key0+'En'])set(store[key0+'En']); } }
    else if(store[key0]!==undefined){ if(raw!==store[key0])set(store[key0]); }
  }

  var dictionaryScript = document.currentScript;
  var dictionaryUrls = [dictionaryScript?.dataset.enDictionary, dictionaryScript?.dataset.hubDictionary].filter(Boolean);
  var dictionaryPending = null, dictionaryLoaded = Object.keys(EN).length > 0, requestedLang = 'pt';
  function ensureEnglish() {
    if (dictionaryLoaded) return Promise.resolve();
    if (dictionaryPending) return dictionaryPending;
    dictionaryPending = dictionaryUrls.reduce(function (previous, url) {
      return previous.then(function () { return new Promise(function (resolve, reject) {
        var script = document.createElement('script'); script.src = url;
        script.onload = resolve; script.onerror = function () { script.remove(); reject(new Error('language_unavailable')); };
        document.head.appendChild(script);
      }); });
    }, Promise.resolve()).then(function () {
      EN = window.LARRYSA_EN || {};
      if (!Object.keys(EN).length) throw new Error('language_unavailable');
      templateKeys = Object.keys(EN).filter(function(k){return k.indexOf('§')!==-1;}).sort(function(a,b){return b.replace(/§/g,'').length-a.replace(/§/g,'').length;});
      dictionaryLoaded = true;
    }).catch(function (error) { dictionaryPending = null; throw error; });
    return dictionaryPending;
  }

  function apply(lang, silent){
    lang = (lang==='en') ? 'en' : 'pt';
    requestedLang = lang;
    if (lang === 'en' && !dictionaryLoaded) {
      return ensureEnglish().then(function () { if (requestedLang === 'en') apply('en', silent); }).catch(function () {
        if (requestedLang !== 'en') return;
        var status = document.getElementById('language-status');
        if (!status) { status = document.createElement('p'); status.id = 'language-status'; status.setAttribute('role', 'status'); document.body.appendChild(status); }
        status.textContent = 'Não foi possível carregar o inglês. Pode tentar novamente ou continuar em português.';
      });
    }
    var languageStatus = document.getElementById('language-status'); if (languageStatus) languageStatus.remove();

    currentLang = lang;
    document.documentElement.setAttribute('lang', lang);
    try{ localStorage.setItem('larrysaLang', lang); }catch(e){}
    walk(document.body, function(t){
      var raw=t.nodeValue; if(!raw) return;
      if(t.__pt===undefined && renderedSources.has(raw.trim())){t.__pt=raw.replace(raw.trim(),renderedSources.get(raw.trim()));t.__en=raw;}
      if(t.__pt!==undefined && raw.replace(/\u00A0/g,' ')!==t.__pt.replace(/\u00A0/g,' ') && raw.replace(/\u00A0/g,' ')!==(t.__en||'').replace(/\u00A0/g,' ')){delete t.__pt;delete t.__en;}
      var key=raw.trim(); if(!key) return;
      var keyN=key.replace(/\u00A0/g,' '); // nbsp da tipografia.js não deve falhar o lookup
      if(lang==='en'){ var en=english(keyN); if(en!==undefined){ if(t.__pt===undefined)t.__pt=raw; t.__en=raw.replace(key,en); if(t.nodeValue!==t.__en)t.nodeValue=t.__en; } }
      else if(t.__pt!==undefined){ if(t.nodeValue!==t.__pt)t.nodeValue=t.__pt; }
    });
    // <title>
    trVal(lang, document.title, TITLE, 't', function(v){ document.title=v; });
    // metas (description / og)
    var metas=document.querySelectorAll('meta[name="description"],meta[property="og:title"],meta[property="og:description"],meta[property="og:image:alt"]');
    for(var m=0;m<metas.length;m++){ (function(el){ el.__s=el.__s||{}; trVal(lang, el.getAttribute('content'), el.__s, 'c', function(v){ el.setAttribute('content',v); }); })(metas[m]); }
    // atributos visíveis/a11y
    var els=document.querySelectorAll('[alt],[aria-label],[placeholder],[title]');
    for(var e=0;e<els.length;e++){ (function(el){ if(el.closest('[translate="no"],.chat-bubble.user,[data-private-copy]'))return; el.__a=el.__a||{};
      ['alt','aria-label','placeholder','title'].forEach(function(an){ if(el.hasAttribute(an)) trVal(lang, el.getAttribute(an), el.__a, an, function(v){ el.setAttribute(an,v); }); });
    })(els[e]); }
    var waLinks=document.querySelectorAll('[data-wa-en]');
    for(var w=0;w<waLinks.length;w++){ (function(el){
      if(!el.__waPtHref) el.__waPtHref=el.getAttribute('href');
      var message=el.getAttribute('data-wa-en');
      var base=el.__waPtHref.split('?')[0];
      el.setAttribute('href', lang==='en' && message ? base+'?text='+encodeURIComponent(message) : el.__waPtHref);
    })(waLinks[w]); }
    var togs=document.querySelectorAll('.langtog');
    for(var i=0;i<togs.length;i++){
      togs[i].classList.toggle('is-en', lang==='en');
      var bs=togs[i].querySelectorAll('button');
      for(var j=0;j<bs.length;j++){ var on=bs[j].getAttribute('data-lang')===lang; bs[j].classList.toggle('on',on); bs[j].setAttribute('aria-pressed', on?'true':'false'); }
    }
    // avisa componentes dinâmicos (ex.: carrinho) para re-renderizarem na língua certa
    if(!silent){ try{ window.dispatchEvent(new CustomEvent('larrysa:lang',{detail:{lang:lang}})); }catch(e){} }
  }

  function makeTog(extra){
    var tog=document.createElement(extra ? 'nav' : 'div'); tog.className='langtog'+(extra?(' '+extra):''); tog.id='langtog'; tog.setAttribute('role',extra ? 'navigation' : 'group'); tog.setAttribute('aria-label','Língua / Language');
    tog.innerHTML='<span class="langtog__knob" aria-hidden="true"></span><button type="button" data-lang="pt" class="on" aria-pressed="true">PT</button><button type="button" data-lang="en" aria-pressed="false">EN</button>';
    return tog;
  }

  function ensureNav(){
    var links=document.querySelector('.nav__links');
    if(!links){
      // página sem nav (hub, 404, encomendas, intro): toggle flutuante,
      // só na janela de topo para não duplicar dentro do iframe do hub
      if(window.self===window.top && !document.querySelector('.langtog')){
        injectStyle();
        document.body.appendChild(makeTog('langtog--float'));
      }
      return false;
    }
    var created=false;
    // O "Início" foi removido da nav: o logótipo (→ hub) e o breadcrumb de mundo
    // já cobrem o "voltar atrás". Não reinjectar para não duplicar nem criar self-links.
    // toggle PT/EN, se faltar (por classe, para não duplicar os hardcoded em bakery/vibes)
    if(!document.querySelector('.langtog')){
      created=true;
      var tog=makeTog();
      var cta=links.querySelector('.is-cta');
      if(cta) links.insertBefore(tog, cta); else links.appendChild(tog);
    }
    return created;
  }

  function bindButtons(){
    var btns=document.querySelectorAll('.langtog button');
    for(var i=0;i<btns.length;i++){
      if(btns[i].__bound) continue; btns[i].__bound=true;
      btns[i].addEventListener('click', function(){ apply(this.getAttribute('data-lang')); });
    }
  }

  function init(){
    var createdTog = ensureNav();
    if(createdTog) injectStyle();
    var saved='pt'; try{ saved=localStorage.getItem('larrysaLang')||'pt'; }catch(e){}
    apply(saved==='en'?'en':'pt');
    bindButtons();
    if(window.LarrysaShopifyConfig){
      var frame=0;
      var observer=new MutationObserver(function(records){
        if(!records.some(function(record){return !record.target.parentElement?.closest('script,style,textarea,[translate="no"],.chat-bubble.user,[data-private-copy]');}))return;
        if(frame)return;
        frame=requestAnimationFrame(function(){frame=0;observer.disconnect();try{window.larrysaApplyLang();}finally{watch();}});
      });
      function watch(){observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['title','alt','aria-label','placeholder']});}
      watch();
    }
  }

  // API global para conteúdo dinâmico (modais, planeador, carrinho):
  // - larrysaApplyLang(): re-traduz o DOM na língua actual (silencioso, sem re-disparar evento)
  // - larrysaT(pt): devolve o EN se a língua é EN e a chave existe, senão o PT
  // - larrysaLang: língua actual ('pt' | 'en')
  window.larrysaApplyLang = function(l){ apply(l===undefined?currentLang:l, true); bindButtons(); };
  window.larrysaT = function(pt){
    var values=Array.prototype.slice.call(arguments,1),index=0;
    var source=(''+pt).replace(/§/g,function(){return values.length?String(values[index++]):'§';});
    var en=english(source.trim());
    if(currentLang==='en' && en!==undefined){var rendered=source.replace(source.trim(),en);renderedSources.set(rendered.trim(),source.trim());return rendered;}
    return source;
  };
  try{ Object.defineProperty(window,'larrysaLang',{get:function(){return currentLang;},configurable:true}); }catch(e){}

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
